export default {
  name: 'PrivacyPolicy'
  // 组件的其他选项和逻辑
};